import * as React from 'react';
import { SVGProps } from 'react';

const SvgInsurance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path fill={props.fill} d="M36.29 17.44v-4.97l-7.65-.03-5.01 5h12.66Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M36.5 11.5v17.49a2.5 2.5 0 0 1-2.5 2.5H6.5a2.5 2.5 0 0 1-2.5-2.5V11.5A2.5 2.5 0 0 1 6.5 9H34a2.5 2.5 0 0 1 2.5 2.5Zm-12.78 10h2.4m1.25 0h6.43m-10.08 5h2.4m1.25 0h6.43"
    />
    <path
      fill="currentColor"
      d="M14.89 26.15c.06 0 .12 0 .12-.08 0-.06-.06-.08-.11-.08h-.1v.16h.09Zm-.09.28h-.08v-.51h.19c.12 0 .18.04.18.15 0 .09-.06.13-.13.14l.14.23h-.09l-.13-.22h-.09v.21h.01Zm.09.12c.2 0 .35-.16.35-.37s-.16-.37-.35-.37c-.2 0-.36.16-.36.37.01.21.16.37.36.37Zm-.44-.37c0-.26.2-.44.44-.44s.44.19.44.44c0 .26-.2.45-.44.45a.453.453 0 0 1-.44-.45Zm-5.42-5.92h4.82l-2.63 2.58H9.03v-2.58Zm5.02 7.48v-7.38l-2.53 2.72v4.66h2.53Zm7.72-7.48h-7.14l2.62 2.58h4.52v-2.58Zm-7.34 5.1v-5l2.53 2.72v2.28h-2.53ZM6.7 19.92h7.15l-2.67-2.57H6.7v2.57Zm7.35-5.1v5.01l-2.53-2.73v-2.28h2.53Zm5.39 5.1h-4.81l2.62-2.57h2.19v2.57Zm-5.01-7.48v7.39l2.53-2.73v-4.66h-2.53Z"
    />
  </svg>
);

export default SvgInsurance;
